import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core'
import { MobileFilterDrawerService } from '@app/v2/shared/services/mobile-filter-drawer.service'

@Component({
  selector: 'app-filter-button',
  standalone: true,
  templateUrl: './filter-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass]
})
export class FilterButtonComponent {
  public readonly activeCount = input(0)
  public readonly clicked = output<void>()

  private readonly _drawerService = inject(MobileFilterDrawerService, { optional: true })

  public onClick(): void {
    if (this._drawerService) {
      this._drawerService.open()
    }

    this.clicked.emit()
  }
}
